import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import Auth from '../Authentication/Auth';
import Api from '../../Services/Api';

class FuelTypeSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fuelTrucksSelectOptions: [],
      fuelMetersSelectOptions: [],
      fuelTrucks: [],
      fuelTruckId: props.selectedTruckValue,
      fuelMeterId: props.selectedTruckValue,
      isLoading: true,
    };

    this.selectTruckChange = this.selectTruckChange.bind(this);
    this.selectMeterChange = this.selectMeterChange.bind(this);
  }

  componentWillMount() {
    this.fetchData(this);
  }

  fetchData() {
    const myHeaders = new Headers();
    const endPoint = `v1/fbos/${this.props.fboId}/fuel_trucks/meters`;

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    this.request = Api.get(endPoint, {
      headers: myHeaders,
    }).then((response) => {
      const fuelTrucks = response.fuelTrucks;

      const fuelTrucksSelectOptions = [];
      fuelTrucks.map(fuelTruck =>
        fuelTrucksSelectOptions.push({ value: fuelTruck.id, label: fuelTruck.name }));

      this.setState({ fuelTrucks, fuelTrucksSelectOptions, isLoading: false });
    });
  }

  updateSelectedMeter(truckId) {
    const currentTruck = this.state.fuelTrucks.find(truck => truck.id === truckId);
    if (currentTruck === undefined) {
      return;
    }

    const fuelMeters = currentTruck.fuelTanks[0].fuelMeters;
    const fuelMetersSelectOptions = [];
    fuelMeters.map(fuelMeter =>
      fuelMetersSelectOptions.push({ value: fuelMeter.id, label: fuelMeter.name }));

    this.setState({ fuelMetersSelectOptions, fuelMeterId: undefined });
  }

  selectMeterChange(inputValue) {
    const fuelMeterId = inputValue === null ? inputValue : inputValue.value;

    this.setState({ fuelMeterId });

    this.props.onSelectionComplete(fuelMeterId);
  }

  selectTruckChange(inputValue) {
    const truckId = inputValue === null ? inputValue : inputValue.value;

    this.setState({ fuelTruckId: truckId }, this.updateSelectedMeter(truckId));

    if (this.props.onSelectTruckChange) {
      this.props.onSelectTruckChange(truckId);
    }
  }

  renderMeterSelect() {
    return (
      <label>
        Select Fuel Meter<br />
        <Select
          id="fuelTruckId"
          name="fuel-type-select"
          value={this.state.fuelMeterId}
          isLoading={this.state.isLoading}
          options={this.state.fuelMetersSelectOptions}
          onChange={this.selectMeterChange}
          clearable={false}
        />
      </label>
    );
  }

  // TODO: Handle multiple tanks on a fuel truck
  renderTankSelect() {
    // return (
    //   <Select
    //     id="fuelTruckId"
    //     name="fuel-type-select"
    //     value={this.state.fuelMeterId}
    //     isLoading={this.state.isLoading}
    //     options={this.state.fuelTrucksSelectOptions}
    //     onChange={this.selectMeterChange}
    //     clearable={true}
    //   />
    // );
  }

  render() {
    return (
      <span>
        <label>
          Select Fuel Truck<br />
          <Select
            id="fuelTruckId"
            name="fuel-type-select"
            value={this.state.fuelTruckId}
            isLoading={this.state.isLoading}
            options={this.state.fuelTrucksSelectOptions}
            onChange={this.selectTruckChange}
            clearable={true}
          />
        </label>
        {this.state.fuelTruckId &&
          this.renderMeterSelect()
        }
      </span>
    );
  }
}

FuelTypeSelect.propTypes = {
  onSelectTruckChange: PropTypes.func,
  onSelectionComplete: PropTypes.func.isRequired,
  selectedTruckValue: PropTypes.number,
  fboId: PropTypes.number.isRequired,
};

FuelTypeSelect.defaultProps = {
  selectedTruckValue: undefined,
  onSelectTruckChange: null
};

export default FuelTypeSelect;



// WEBPACK FOOTER //
// ./src/Containers/FuelMeters/FuelMeterSelect.js